import { Button, ButtonProps } from '../button/button';
import { aiWand } from './ai-wand.css';
import { Sparkle } from './sparkle';

export const SparkleButton = ({ children, ...buttonProps }: ButtonProps) => {
  return (
    <Button
      size="xs"
      variant="secondary"
      className={aiWand}
      aria-label="AI enhance"
      type="button"
      containerStyle={{ gap: 8, alignItems: 'center' }}
      {...buttonProps}
    >
      <Sparkle style={{ backgroundColor: 'transparent' }} />
      {children}
    </Button>
  );
};
